import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Profile from '../../components/Profile'

class Cprofile extends Component{    
    render(){
        return <Profile />
    }
}

const mapStateToProps = state => {
    return {
        profileState : state.profile.profileState
    }
}

export default connect(mapStateToProps)(withRouter(Cprofile));



// WEBPACK FOOTER //
// ./src/containers/Cprofile/index.js